import { Pipe, PipeTransform } from '@angular/core';
import { toZonedTime, format } from 'date-fns-tz';

@Pipe({
  name: 'localDate'
})
export class LocalDatePipe implements PipeTransform {

  transform(value: string | Date, timeZone: string = 'America/Bogota', dateFormat: string = 'dd/MM/yyyy HH:mm'): string {
    if (!value) {
      return '';
    }

    // Ensure the date string is treated as UTC by appending 'Z' if it's missing
    const dateString = typeof value === 'string' && !value.endsWith('Z') ? `${value}Z` : value;

    try {
      // 1. Convert the incoming date from UTC to the target time zone
      const zonedDate = toZonedTime(new Date(dateString), timeZone);
      // 2. Format the resulting date
      return format(zonedDate, dateFormat, { timeZone });
    } catch (error) {
      console.error('Error formatting date:', error);
      // Fallback for invalid dates
      return value.toString();
    }
  }
} 